import gql from 'graphql-tag';
import {useQuery} from './query';

// Gets all sweeps for the given project

///// Query definition
export const PROJECT_ARTIFACTS_QUERY = gql`
  query ProjectArtifacts($projectName: String!, $entityName: String!) {
    project(name: $projectName, entityName: $entityName) {
      id
      artifactTypes {
        edges {
          node {
            id
            name
            description
            artifactSequences {
              totalCount
            }
          }
        }
      }
    }
  }
`;

// // These types define the inputs and outputs of the above gql query

interface ArtifactData {
  id: string;
  digest: string;
  createdAt: string;
}

interface ProjectData {
  id: string;

  artifactTypes: {
    edges: Array<{
      node: {
        id: string;
        name: string;
        description: string;
        artifactSequences: {
          totalCount: number;
        };
      };
    }>;
  };
}

// The query's output shape.
interface Data {
  project: ProjectData;
}

export function useProjectArtifactsQuery(variables: {
  entityName: string;
  projectName: string;
}) {
  return useQuery<Data, typeof variables>(PROJECT_ARTIFACTS_QUERY, {
    variables,
  });
}
